export default __webpack_public_path__ + "static/media/logo.fa11e90c.svg";